import React, { Component } from "react";
import $ from 'jquery'
import '../assets/css/font-awesome.min.css';
import '../assets/fonts/fonts.css';
import './Custom.css';

class LandingPage extends Component {
  
    render() {
        return (
            <div className='App'>
                <div className='landing-page-wrapper'>
                    <div className="landing-page-bg"></div>
                    <div className="container">
                        <div className="top-row">
                            <div className="top-row-mobile">
                                <img src={require('../assets/images/all_mobile_box.png')} alt="mobile-logo" />
                            </div>
                            <div className="top-row-left top-row-img">
                                <img src={require('../assets/images/adidas_puma_box.png')} alt="adidas_puma_box" />
                            </div>
                            <div className="top-row-center">
                                <img src={require('../assets/images/main_logo.png')} alt="main_logo" />
                                <ul className="storelist">
                                <li>
                                    <a href="https://apps.apple.com/tr/app/kicksfinder/id1568257758" target="_blank" rel="noopener noreferrer">
                                        <img src={require('../assets/images/appstore.png')} className="app-img" alt="app logo" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://play.google.com/store/apps/details?id=com.kicksfinder.app&hl=en_US&pli=1" target="_blank" rel="noopener noreferrer">
                                        <img src={require('../assets/images/playstore.png')} className="app-img" alt="app logo" />
                                    </a>
                                </li>
                            </ul>
                            </div>
                            <div className="top-row-right top-row-img">
                                <img src={require('../assets/images/nike_jordan_box.png')} alt="nike_jordan_box" />
                            </div>
                        </div>
                        <div className="mid-content">
                            <div className="mid-content-lhs mid-content-data">
                                <i className="mid_icon mid_icon_drops"></i>
                                <h4 className="mid_title">drops</h4>
                                <p className="mid_data">Keep up to date with the <br/>latest sneaker releases, and <br/>never miss a drop again.</p>
                                <div className="mid-content-lhs-img mid-content-prod">
                                    <img src={require('../assets/images/mid_lhs.png')} alt="mid_lhs" />
                                </div>
                            </div>
                            <div className="mid-content-video">
                                <div className="mid-content-video-body"><img src={require('../assets/images/app_video_body.png')} alt="app_video_body" /></div>
                                <div className="mid-content-video-play">
                                    <video src={require('../assets/images/app_landing_video.mp4')} autoPlay loop muted playsInline></video>
                                    </div>
                            </div>
                            <div className="mid-content-rhs mid-content-data">
                                <i className="mid_icon mid_icon_vault"></i>
                                <h4 className="mid_title">VAULT</h4>
                                <p className="mid_data">Access an online database of the most <br/>popular sneakers from Nike, Jordan, <br/>adidas and other footwear brands.</p>
                                <div className="mid-content-rhs-img mid-content-prod">
                                    <img src={require('../assets/images/mid_rhs.png')} alt="mid_rhs" />
                                </div>
                            </div>
                        </div>
                        <div className="bottom-row">
                            <img src={require('../assets/images/kf_bottom_logo.png')} alt="kf_bottom_logo" className="kf_bottom_logo" />
                            <div className="bottom-row-text">
                                <h4>Download the KicksFinder App Now</h4>
                                <p>For phones & tablets on iOS and Android.</p>
                                <ul>
                                    <li>
                                    <a href="https://apps.apple.com/tr/app/kicksfinder/id1568257758" target="_blank" rel="noopener noreferrer">
                                        Go to App Store
                                    </a>
                                </li>
                                <li>
                                    <a href="https://play.google.com/store/apps/details?id=com.kicksfinder.app&hl=en_US&pli=1" target="_blank" rel="noopener noreferrer">
                                        Go to Google Play Store
                                    </a>
                                </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LandingPage